<template>
  <div>
    <v-list-item @click.prevent="getHelp">
      <v-list-item-icon>
        <v-icon :small="$root.isAdminRoute">
          fas fa-fw fa-question-circle
        </v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title>
          Get Help
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <v-dialog v-model="showCustomHelp"
              max-width="500">
      <v-card>
        <v-card-title>
          How to Get Help
        </v-card-title>
        <v-card-text>
          {{ team.support_instructions }}
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import {mapGetters} from 'vuex';
import helpScoutService from '../../../ml/services/helpScoutService';

export default {
  name: 'help-menu-item',
  data() {
    return {
      showCustomHelp: false,
    }
  },
  computed: {
    ...mapGetters([
      'team',
      'user',
    ])
  },
  methods: {
    getHelp() {
      if (this.team?.support_instructions) {
        this.showCustomHelp = true;
      } else if (!this.team || this.team.is_support_standard) {
        helpScoutService.show(this.user);
      } else {

      }
    }
  }
}
</script>
